/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { UserAccountDto } from "./UserAccountDto";
import {
    UserAccountDtoFromJSON,
    UserAccountDtoFromJSONTyped,
    UserAccountDtoToJSON,
} from "./UserAccountDto";

/**
 *
 * @export
 * @interface UserAccountInvitationRequest
 */
export interface UserAccountInvitationRequest {
    /**
     *
     * @type {UserAccountDto}
     * @memberof UserAccountInvitationRequest
     */
    userAccount?: UserAccountDto;
    /**
     *
     * @type {string}
     * @memberof UserAccountInvitationRequest
     */
    invitationMessage?: string;
}

/**
 * Check if a given object implements the UserAccountInvitationRequest interface.
 */
export function instanceOfUserAccountInvitationRequest(
    value: object,
): value is UserAccountInvitationRequest {
    return true;
}

export function UserAccountInvitationRequestFromJSON(
    json: any,
): UserAccountInvitationRequest {
    return UserAccountInvitationRequestFromJSONTyped(json, false);
}

export function UserAccountInvitationRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UserAccountInvitationRequest {
    if (json == null) {
        return json;
    }
    return {
        userAccount:
            json["userAccount"] == null
                ? undefined
                : UserAccountDtoFromJSON(json["userAccount"]),
        invitationMessage:
            json["invitationMessage"] == null
                ? undefined
                : json["invitationMessage"],
    };
}

export function UserAccountInvitationRequestToJSON(
    value?: UserAccountInvitationRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        userAccount: UserAccountDtoToJSON(value["userAccount"]),
        invitationMessage: value["invitationMessage"],
    };
}
